(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-accordion')) {
    class ProductAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.openFirst = this.dataset.openFirst === 'true';

        this.items.forEach((item, index) => {
          const trigger = item.querySelector('.product-accordion__trigger');
          const panel = item.querySelector('.product-accordion__panel');

          if (!trigger || !panel) return;

          if (!this.openFirst || index !== 0) {
            this.closeItem(item);
          }

          trigger.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            if (isOpen) {
              this.closeItem(item);
            } else {
              this.items.forEach((otherItem) => {
                if (otherItem !== item) this.closeItem(otherItem);
              });
              this.openItem(item);
            }
          });
        });
      }

      openItem(item) {
        const trigger = item.querySelector('.product-accordion__trigger');
        const panel = item.querySelector('.product-accordion__panel');
        if (!trigger || !panel) return;

        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }

      closeItem(item) {
        const trigger = item.querySelector('.product-accordion__trigger');
        const panel = item.querySelector('.product-accordion__panel');
        if (!trigger || !panel) return;

        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    customElements.define('product-accordion', ProductAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
